import { RootState } from '../../store';

export const getAppConnected = (state: RootState) => state.mobileClient.appConnected;

export const getCurrentUrlInput = (state: RootState) =>
  state.mobileClient.currentUrlInput;
